import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalContentMessage: {
    description: 'Content message of the modal',
    id: 'qBD7Jy',
    defaultMessage: 'This is your last chance to copy the keys. Once you close this window, you won’t be able to see it again.',
  },
});
